/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___  
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || | 
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v2.0.0 Beta
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)


=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Flex, Icon, Text } from "@chakra-ui/react";
// Assets
// Custom components
import InnerContent from "layouts/innerContent";
import React from "react";
import {
	CREATIVETIM,
	SOLARVISION,
	CITYDOCK,
	BOOKIFY,
	EDUWIZ,
} from "components/icons/Icons";
import { TTSGENERATOR } from "components/icons/Icons";

export default function Hero() {
	// Chakra Color Mode
	return (
		<Flex
			w='100%'
			direction='column'
			pt={{
				base: "30px",
				md: "70px",
				xl: "70px",
				"2xl": "70px",
				"3xl": "70px",
			}}
			position='relative'>
			<InnerContent
				w='1170px'
				maxW='100%'
				px={{ base: "0px", md: "40px", xl: "0px" }}
				zIndex='2'>
				<Text
					color='#A5AAB2'
					textAlign={{ base: "center" }}
					fontWeight={"700"}
					fontSize={{ base: "xs", lg: "md" }}
					letterSpacing='2px'
					w={{ base: "60%", md: "100%" }}
					mb='40px'>
					WE HAVE CREATED AWESOME WORKS FOR:
				</Text>
				<Flex
					flexWrap={{ base: "wrap", xl: "nowrap" }}
					justify='center'
					alignItems='center'
					gap='60px'
					mb='40px'>
					<Icon
						w={{ base: "130px", md: "161px" }}
						h={{ base: "36px", md: "35px" }}
						color='#A5AAB2'
						as={EDUWIZ}
					/>
					<Icon
						w={{ base: "130px", md: "194px" }}
						h={{ base: "36px", md: "37px" }}
						color='#A5AAB2'
						as={TTSGENERATOR}
					/>
					<Icon
						w={{ base: "130px", md: "107px" }}
						h={{ base: "36px", md: "34px" }}
						color='#A5AAB2'
						as={CREATIVETIM}
					/>
					<Icon
						w={{ base: "126px", md: "217px" }}
						h={{ base: "36px", md: "30px" }}
						color='#A5AAB2'
						as={SOLARVISION}
					/>
					<Icon
						w={{ base: "130px", md: "160px" }}
						h={{ base: "36px", md: "29px" }}
						color='#A5AAB2'
						as={CITYDOCK}
					/>
					<Icon
						w={{ base: "100px", md: "116px" }}
						h={{ base: "36px", md: "40px" }}
						color='#A5AAB2'
						as={BOOKIFY}
					/>
				</Flex>
			</InnerContent>
		</Flex>
	);
}
